<template>
  <el-row :gutter="50" class="resource-list">
    <el-col
      :xs="24"
      :sm="12"
      v-for="(item, index) in resources"
      :key="'resource' + index"
      class="item"
    >
      <div v-if="mode === 1 ? index < 2 : index > 1">
        <div class="title">{{ item.title }}</div>
        <div class="list">
          <a
            class="res-item"
            v-for="(res, index) in item.list"
            :key="'res_' + index"
            :href="'https://rm.ulearning.cn/#/resourceDetail/' + res.id"
            target="_blank"
          >
            <el-row :gutter="15">
              <el-col class="name" :span="19">{{ res.name }}</el-col>
              <el-col class="time" :span="5">{{
                res.publishTime | timeFormat
              }}</el-col>
            </el-row>
          </a>
        </div>
        <a
          class="res-see-more pc"
          :href="'https://rm.ulearning.cn/#/portal/351/' + item.folderId"
          target="_blank"
          >查看全部</a
        >
        <a
          class="viewMore mobile"
          :href="'https://rm.ulearning.cn/#/portal/351/' + item.folderId"
          target="_blank"
        >
          查看全部<i class="iconfont icondata_next"></i>
        </a>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import util from "@/libs/util.js";
export default {
  name: "resourceItem",
  props: {
    resources: {
      tyle: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      list: [],
    };
  },
  filters: {
    timeFormat(value) {
      return util.timeFormat(value, "MM-dd");
    },
  },
};
</script>
<style lang="scss" scoped>
.resource-list {
  text-align: left;
  a {
    text-decoration: none;
  }
  .title {
    position: relative;
    padding-left: 15px;
    line-height: 26px;
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: bold;
    color: #111111;
    &::before {
      position: absolute;
      top: 2px;
      left: 0;
      width: 5px;
      height: 20px;
      border-radius: 2.5px;
      display: block;
      content: " ";
      background-image: -webkit-linear-gradient(bottom, #dd0000, #ffbb20);
    }
  }
  .list {
    margin-bottom: 30px;
    .res-item {
      display: block;
      width: 100%;
      padding: 14px 0;
      line-height: 20px;
      border-bottom: 1px solid #ebebec;
      cursor: pointer;
      color: #444444;
      box-sizing: border-box;
      font-size: 14px;
      position: relative;
      &:hover {
        color: #dd0000;
      }
      &:last-child {
        border-bottom: 0;
      }
      .name {
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .time {
        text-align: right;
        color: #888888;
      }
    }
  }
  .res-see-more {
    display: block;
    width: 100px;
    padding: 6px 10px;
    line-height: 20px;
    border: 1px solid #dd0000;
    color: #dd0000;
    text-align: center;
    border-radius: 3px;
    box-sizing: border-box;
    cursor: pointer;
    font-size: 14px;
    &:hover {
      background-color: rgba(221, 0, 0, 0.2);
    }
  }
  .item {
    position: relative;
    .viewMore {
      position: absolute;
      right: 20px;
      top: 2px;
      font-size: 12px;
      color: #969696;
      line-height: 21px;
      cursor: pointer;
      .iconfont {
        font-size: 14px;
      }
      &:hover {
        color: #dd0000;
      }
    }
  }
  @media (max-width: 767px) {
    padding-top: 0;
    .title {
      margin-bottom: 2px;
      font-size: 16px;
      max-width: 76%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .list {
      margin-bottom: 22px;
    }
  }
}
</style>